import React, { useEffect, useState } from "react";
import {
  Table,
  Checkbox,
  Tooltip,
  Spin,
  message,
  Modal,
  Avatar,
} from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { MdBlockFlipped } from "react-icons/md";

import { Link, useNavigate } from "react-router-dom";

import ErrorLogout from "../../../helpers/ErrorLogout";
import {
  getAllSurveyor,
  updateSurveyorStatus,
} from "../../../api/CommonRequest";
import Pagination from "../Pagination";

const { confirm } = Modal;

const SurveyorList = ({ pages }) => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);

  const [activeTab, setActiveTab] = useState("");
  const [totalPages, setTotalPages] = useState(5);
  const [limit, setLimit] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [trigger, setTrigger] = useState(false);
  const [searchName, setSearchName] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);

  const [tabFilter, setTabFilter] = useState(""); // Update initial state to 'all'
  const [user, setUser] = useState([]); // Update initial state to '
  const tabs = [
    { label: "All", value: "" },
    { label: "Active", value: "active" },
    { label: "Deactive", value: "deactive" },
  ];

  useEffect(() => {
    const bidsCall = async () => {
      try {
        setLoader(true);

        const { data } = await getAllSurveyor({
          q: searchName,

          page: currentPage,
          limit: limit,
          status: tabFilter,
        });
        if (data?.success) {
          setUser(data?.surveyorList);
          setTotalPages(data?.totalPages);
          setCurrentPage(data?.currentPage);
          setTotalItems(data?.totalItems);
          setLoader(false);
        }
      } catch (error) {
        setLoader(false);

        console.log(error);
        console.log(error.message);
        if (error?.response?.status === 401) {
          ErrorLogout(error);
        }
      }
    };
    bidsCall();
  }, [limit, currentPage, tabFilter, trigger]);

  // -------------------- CREATE AND EDIT PAGE------------------

  const handleEdit = (data) => {
    navigate("/surveyor-edit", { state: data });
  };
  const handleSingleView = (data) => {
    navigate("/surveyor-single-view", { state: data });
  };

  // -------------- UPDATE STATUS--------------
  const handleUpdateStatus = async (record, status) => {
    confirm({
      title: `Do you want to ${status} ${record.name}?`,
      icon: <ExclamationCircleOutlined />,
      content: `This action will ${status} the surveyor. Are you sure you want to proceed?`,
      okText: "Yes",
      okType: "primary",
      cancelText: "No",
      onOk: async () => {
        try {
          setLoader(true);
          // const { data } = await updateSurveyorStatus(record._id, status);
          const { data } = await updateSurveyorStatus(record._id, status);
          if (data?.success) {
            message.success(`Surveyor ${status}d successfully.`);
            setTrigger(!trigger);
          } else {
            message.error(`Failed to ${status} surveyor.`);
          }
        } catch (error) {
          console.log(error);
          console.log(error.message);
          if (error?.response?.status === 401) {
            ErrorLogout(error);
          }
          message.error(
            `An error occurred while trying to ${status} the surveyor.`
          );
        } finally {
          setLoader(false);
        }
      },
      onCancel() {
        console.log("Action canceled");
      },
    });
  };

  // --------- PAGINATION HANDLERS-------
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  const handleLimit = (e) => {
    const selectedValue = parseInt(e.target.value); // Convert value to integer if needed
    setLimit(selectedValue); // Update state with the selected value
    setCurrentPage(1);
  };

  const columns = [
    {
      title: "Select",
      dataIndex: "select",
      width: 60,
      render: (_, record) => (
        <Checkbox
          checked={selectedUsers.some((user) => user._id === record._id)}
        // onChange={() => handleSelectUser(record)}
        />
      ),
    },
    {
      title: (
        <div className="flex items-center gap-2">
          Surveyor Name
        </div>
      ),
      dataIndex: "name",
      key: "name",
      render: (_, record) => (
        <div className="flex items-center">
          {record?.profileImage ? (
            <img
              src={record.profileImage}
              alt="User avatar"
              className="w-8 h-8 rounded-full mr-2"
            />
          ) : (
            <Avatar icon={<UserOutlined />} className="w-8 h-8 mr-2" />
          )}
          <span className="text-[#313131] text-[12px] font-medium">
            {record.name}
          </span>
        </div>
      ),
    },
    {
      title: (
        <div className="flex items-center gap-2">
          Email
        </div>
      ),
      dataIndex: "email",
      key: "email",
      render: (text) => (
        <span className="text-[#313131] text-[12px] font-medium">{text}</span>
      ),
    },
    {
      title: (
        <div className="flex items-center gap-2">
          Phone
        </div>
      ),
      dataIndex: "phone",
      key: "phone",
      render: (text) => (
        <span className="text-[#313131] text-[12px] font-medium">{text}</span>
      ),
    },
    {
      title: (
        <div className="flex items-center gap-2">
          Status
        </div>
      ),
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <div className="flex items-center gap-2">
          <span
            className={`py-1 rounded-full text-xs ${status === "active"
              ? "text-green-600"
              : status === "deactive"
                ? "text-yellow-500"
                : status === "delete"
                  ? "text-gray-600"
                  : "text-red-600"
              }`}
          >
            {status === "active"
              ? "Active"
              : status === "deactive"
                ? "Deactive"
                : status === "delete"
                  ? "Deleted"
                  : status.charAt(0).toUpperCase() + status.slice(1)}
          </span>
        </div>
      ),
    },

    {
      title: (
        <div className="flex items-center gap-2">
          State
          {/* <SearchOutlined className="text-[#9FACF0]" /> */}
        </div>
      ),
      dataIndex: "roleDetails",
      key: "roleDetails",
      render: (text) => (
        <span className="text-[#313131] text-[12px] font-medium">{text.state}</span>
      ),
    },
    {
      title: (
        <div className="flex items-center gap-2">
          District
          {/* <SearchOutlined className="text-[#9FACF0]" /> */}
        </div>
      ),
      dataIndex: "roleDetails",
      key: "roleDetails",
      render: (text) => (
        <span className="text-[#313131] text-[12px] font-medium">{text.district}</span>
      ),
    },
    {
      title: (
        <div className="flex items-center gap-2">
          City
          {/* <SearchOutlined className="text-[#9FACF0]" /> */}
        </div>
      ),
      dataIndex: "roleDetails",
      key: "roleDetails",
      render: (text) => (
        <span className="text-[#313131] text-[12px] font-medium">{text.city}</span>
      ),
    },


    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <div className="flex items-center gap-2">
          <Tooltip title="View Details">
            <button
              onClick={() => handleSingleView(record._id)}
              className="w-8 h-8 flex items-center justify-center bg-blue-50 text-[#1955EB] rounded-lg hover:bg-[#1955EB] hover:text-white transition-all shadow-sm border border-blue-100"
            >
              <EyeOutlined style={{ fontSize: 16 }} />
            </button>
          </Tooltip>
          <Tooltip title="Edit">
            <button
              onClick={() => handleEdit(record)}
              className="w-8 h-8 flex items-center justify-center bg-blue-50 text-[#1955EB] rounded-lg hover:bg-[#1955EB] hover:text-white transition-all shadow-sm border border-blue-100"
            >
              <EditOutlined style={{ fontSize: 16 }} />
            </button>
          </Tooltip>
          <Tooltip
            title={
              record.status === "delete"
                ? "Disabled"
                : record.status === "deactive"
                  ? "Activate"
                  : "Deactivate"
            }
          >
            <button
              onClick={() => {
                if (record.status !== "delete") {
                  handleUpdateStatus(
                    record,
                    record.status === "deactive" ? "active" : "deactive"
                  );
                }
              }}
              className={`w-8 h-8 flex items-center justify-center rounded-lg transition-all shadow-sm border ${record.status === "delete"
                ? "bg-gray-100 text-gray-400 cursor-not-allowed border-gray-200"
                : record.status === "deactive"
                  ? "bg-green-50 text-green-600 border-green-100 hover:bg-green-600 hover:text-white"
                  : "bg-gray-100 text-[#4A4A4C] border-gray-200 hover:bg-[#4A4A4C] hover:text-white"
                }`}
              disabled={record.status === "delete"}
            >
              <MdBlockFlipped size={16} />
            </button>
          </Tooltip>
          <Tooltip title={record.status === "delete" ? "Activate" : "Delete"}>
            <button
              onClick={() =>
                handleUpdateStatus(
                  record,
                  record.status === "delete" ? "active" : "delete"
                )
              }
              className={`w-8 h-8 flex items-center justify-center rounded-lg transition-all shadow-sm border ${record.status === "delete"
                ? "bg-green-50 text-green-600 border-green-100 hover:bg-green-600 hover:text-white"
                : "bg-red-50 text-red-600 border-red-100 hover:bg-red-600 hover:text-white"
                }`}
            >
              <DeleteOutlined style={{ fontSize: 16 }} />
            </button>
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <div className="flex-grow overflow-y-auto scrollbar-hide p-4 lg:p-6 md:p-5">
      <div className="">
        <div className="lg:sticky top-0 pb-3 lg:z-10 bg-white">
          <div className="flex justify-between items-center mb-4 flex-wrap gap-2">
            <div className="flex border border-[#9FACF0] p-1.5 gap-1.5 rounded-[12px] w-max bg-white">
              {tabs.map((tab) => (
                <button
                  key={tab.value}
                  className={`h-10 px-6 whitespace-nowrap rounded-lg text-sm transition-all duration-200
                 ${activeTab === tab.value
                      ? "bg-white text-[#1955EB] font-semibold shadow-sm border border-blue-100"
                      : "bg-transparent text-gray-500 hover:bg-gray-50 font-medium"
                    }`}
                  onClick={() => {
                    setActiveTab(tab.value);
                    setTabFilter(tab.value);
                    setCurrentPage(1);
                  }}
                >
                  {tab.label}
                </button>
              ))}
            </div>
            <div className="flex flex-wrap gap-2">
              <Link to="/surveyor-create">
                <button className="px-5 py-2 text-[16px] font-medium text-white bg-[#1955EB] hover:border-[#1955EB] border-[1px] rounded-md hover:bg-white hover:text-[#1955EB]">
                  + Create Surveyor
                </button>
              </Link>
            </div>
          </div>
        </div>
        <Spin spinning={loader}>
          <div className="pt-0">
            <Table
              columns={columns}
              dataSource={user}
              pagination={false}
              className="custom-table-header overflow-scroll custom-pagination border border-gray-100 rounded-xl"
            />
            <div className="mt-6">
                <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                limit={limit}
                totalItem={totalItems}
                onPageChange={handlePageChange}
                handleLimit={handleLimit}
              />
            </div>
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default SurveyorList;
